<utc-product-card [product]="productCard" [mode]="mode"></utc-product-card>
